import React from 'react';

import { Container, Titles, Title, Subtitle, Actions } from './styles';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Ações primárias da página (ex.: botão "Novo Curso"). */
  actions?: React.ReactNode;
}

/**
 * Cabeçalho de página do admin: título, subtítulo opcional e a ação primária
 * sempre no mesmo lugar (à direita). É o ponto de entrada de qualquer tela.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => {
  return (
    <Container>
      <Titles>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Titles>
      {actions && <Actions>{actions}</Actions>}
    </Container>
  );
};

export default PageHeader;
